export default __webpack_public_path__ + "static/media/lockrScan-admin-next.84a63136.svg";